import React, {Component} from 'react'
import {FormattedMessage} from 'react-intl'

class BillingMethodPriceLabel extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            billingMethod: this.props.billingMethod || '',
            pricingStrategy: this.props.pricingStrategy || '',
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            billingMethod: nextProps.billingMethod || '',
            pricingStrategy: nextProps.pricingStrategy || '',
        })
    }

    componentDidMount() {}

    renderOneTime() {
        switch (this.state.pricingStrategy) {
            case "multiplier":
            case "custom-formula":
                return <FormattedMessage
                    id="common.billing_method.one_time.label.multiplier.price_label"
                    defaultMessage="Unit price"
                />
            case "bracket":
                return <FormattedMessage
                    id="common.billing_method.one_time.label.bracket.price_label"
                    defaultMessage="Box unit price"
                />
            case "bracket-custom":
                return <FormattedMessage
                    id="common.billing_method.one_time.label.custom_bracket.price_label"
                    defaultMessage="Bracket price"
                />
            case "bulk":
                return <FormattedMessage
                    id="common.billing_method.one_time.label.bulk.price_label"
                    defaultMessage="Unit price"
                />
        }
        return ''
    }

    renderMonthly() {
        switch (this.state.pricingStrategy) {
            case "multiplier":
            case "custom-formula":
                return <FormattedMessage
                    id="common.billing_method.monthly.label.multiplier.price_label"
                    defaultMessage="Monthly unit price"
                />
            case "bracket":
                return <FormattedMessage
                    id="common.billing_method.monthly.label.bracket.price_label"
                    defaultMessage="Monthly box unit price"
                />
            case "bracket-custom":
                return <FormattedMessage
                    id="common.billing_method.monthly.label.custom_bracket.price_label"
                    defaultMessage="Monthly bracket price"
                />
            case "bulk":
                return <FormattedMessage
                    id="common.billing_method.monthly.label.bulk.price_label"
                    defaultMessage="Monthly unit price"
                />
        }
        return ''
    }

    renderYearly() {
        switch (this.state.pricingStrategy) {
            case "multiplier":
            case "custom-formula":
                return <FormattedMessage
                    id="common.billing_method.yearly.label.multiplier.price_label"
                    defaultMessage="Yearly unit price"
                />
            case "bracket":
                return <FormattedMessage
                    id="common.billing_method.yearly.label.bracket.price_label"
                    defaultMessage="Yearly box unit price"
                />
            case "bracket-custom":
                return <FormattedMessage
                    id="common.billing_method.yearly.label.custom_bracket.price_label"
                    defaultMessage="Yearly bracket price"
                />
            case "bulk":
                return <FormattedMessage
                    id="common.billing_method.yearly.label.bulk.price_label"
                    defaultMessage="Yearly unit price"
                />
        }
        return ''
    }


    render() {
        switch (this.state.billingMethod) {
            case "one-time":
                return this.renderOneTime()
            case "monthly":
                return this.renderMonthly()
            case "yearly":
                return this.renderYearly()
        }
        return ''
    }
}

export default BillingMethodPriceLabel





// WEBPACK FOOTER //
// ./src/product/billing-method/pricelabel.component.jsx